import * as classnames from 'classnames/bind'
import * as React from 'react'
import { connect } from 'react-redux'
import LectureItem from '../../components/LectureItem'
import BasicLayout from '../../layouts/BasicLayout'
import layoutStyles from '../../layouts/BasicLayout/basic-layout.scss'
import { RootState, select, store } from '../../store'
import styles from './explore-page.scss'

const cx = classnames.bind({ ...layoutStyles, ...styles })

interface IProps extends Partial<ReturnType<typeof mapState>> {

}

class ExplorePage extends React.Component<IProps> {
  public render() {
    const rootState = store.getState()
    const verifiedLectureIds = select.lectures.getVerifiedLectureIds(rootState)
    return (
      <BasicLayout>
        <div className={cx('explore-bg')} />

        <div className={cx('container')}>
          <div className={cx('bg-quote', 'explore-quote')} />
        </div>

        <div className={cx('container')}>
          <div className={cx('explore-bar')}>
            <div className={cx('page-title-container--v1')}>
              <h3 className={cx('page-title')}>探索講座</h3>
            </div>
            {/* <div className={cx('explore-toggle-group')}>
              <div className={cx('explore-toggle-btn')}>全部講座</div>
              <ul className={cx('explore-toggle-content')}>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link', 'active')}>全部講座</a>
                </li>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link')}>已開講</a>
                </li>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link')}>即將開講</a>
                </li>
              </ul>
            </div>
            <div className={cx('explore-toggle-group')}>
              <div className={cx('explore-toggle-btn')}>類別</div>
              <ul className={cx('explore-toggle-content')}>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link', 'active')}>生活</a>
                </li>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link')}>科技</a>
                </li>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link')}>行銷</a>
                </li>
                <li className={cx('explore-toggle-content__item')}>
                  <a href="#!" className={cx('explore-toggle-content__link')}>旅行</a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>


        <div className={cx('explore-group')}>
          <div className={cx('container')}>
            <div className={cx('bg-group', 'mobile-hidden')}>
            </div>
            <div className={cx('row')}>
              {
                verifiedLectureIds ? verifiedLectureIds.map(lectureId => (
                  <div key={lectureId} className={cx('col-md-6', 'col-lg-4')}>
                    <div className={cx('lecture-item')}>
                      <LectureItem lectureId={lectureId} />
                    </div>
                  </div>
                )) : '載入中'
              }
            </div>
          </div>
        </div>

        <div className={cx('towish')}>
          <div className={cx('container')}>
            <div className={cx('inner')}>
              <h4 className={cx('title')}>找不到你想要的主題嗎？</h4>
              <p className={cx('subtitle')}>留下你的願望，我們幫你實現</p>
              <a href="https://louissyue.typeform.com/to/nLtnv7" target="_blank" className={cx('btn', 'btn--md', 'btn--primary', 'btn--shadow')}>前往許願</a>
            </div>
          </div>
        </div>

      </BasicLayout>
    )
  }
}

const mapState = ({ lectures }: RootState) => ({
  lectures
})

export default connect(mapState)(ExplorePage)



// WEBPACK FOOTER //
// ./src/pages/ExplorePage/index.tsx